import DefaultLayout from '##/Default';
import ViewDelinquencies from './ViewDelinquencies';
import DelinquencyForm from './DelinquencyForm';

const routes = [
    {
        path: '/properties/:property_id/reports/delinquencies',
        exact: true,
        layout: DefaultLayout,
        component: ViewDelinquencies,
        auth: true,
        title: 'Delinquency Reports'
    },

    {
        path: '/reports/:property_id/delinquencies/:id',
        exact: true,
        layout: DefaultLayout,
        component: DelinquencyForm,
        auth: true,
        title: 'Delinquency Reports'
    }
];


export default routes;
